import { Link } from 'react-router-dom';
import { currentStepOf, secondaryOf } from '@/domain/workflow/approaches';
import { useLoad } from '../hooks/useLoad';
import { useService } from '../hooks/useService';

/**
 * 치료 방향 한 줄 (A33): 채택했으면 지금 단계와 할 일, 아니면 추천이 생겼을 때만 알린다.
 * 다음 회기 준비·회기 마무리에서 쓴다.
 */
export function TreatmentLine({
  clientId,
  canAdvance,
}: {
  clientId: string;
  /** 마무리에서: 이번 회기에 이 단계를 마쳤으면 바로 표시 */ canAdvance?: boolean;
}) {
  const svc = useService();
  const { data, reload } = useLoad(() => svc.approachBoard(clientId), [svc, clientId]);
  if (!data) return null;
  const path = `/clients/${clientId}/treatment`;
  const c = currentStepOf(data.plan);
  if (c && !c.completed)
    return (
      <div className="card treatment-line">
        <p>
          <strong>치료 방향</strong> {c.approach.name} ·{' '}
          {c.allStepsDone ? '모든 단계를 마침' : `${c.index + 1}/${c.total}단계 ${c.step!.title}`}{' '}
          <Link to={path}>단계 보기</Link>
        </p>
        {c.step && <p className="muted small">{c.step.guide}</p>}
        {secondaryOf(data.plan) && (
          <p className="muted small">
            보조: {secondaryOf(data.plan)!.approach.name}
            {secondaryOf(data.plan)!.role ? ` · ${secondaryOf(data.plan)!.role}` : ''}
          </p>
        )}
        {canAdvance && c.step && (
          <button
            type="button"
            className="small"
            onClick={() => void svc.setTreatmentStep(clientId, c.index + 1).then(reload)}
          >
            이번 회기에 이 단계 끝 →
          </button>
        )}
      </div>
    );
  if (!data.plan && data.recommendation.approach)
    return (
      <div className="card treatment-line">
        <p>
          <strong>치료 방향 추천</strong> {data.recommendation.approach.name} — {data.recommendation.note}{' '}
          <Link to={path}>보고 정하기</Link>
        </p>
      </div>
    );
  return null;
}
